import { getSnapshot, types } from 'mobx-state-tree'
// import { Options } from "."
import { DOMAIN_ACTION } from '@/constants'
import { IValueChange } from '@/pages/supplier/listing/definition/accountDetails'
import { axiosPrivateHelper } from '@/utils/axiosHelper'
const axios = axiosPrivateHelper()

const Options = types.model('Options').props({
  isDraft: types.boolean,
})

const PromotionSubmitModel = types.model('PromotionSubmitModel').props({
  id: types.maybeNull(types.string),
  title: types.maybeNull(types.string),
  description: types.maybeNull(types.string),
  startDate: types.maybeNull(types.string),
  endDate: types.maybeNull(types.string),
  link: types.maybeNull(types.string),
  status: types.optional(types.string, 'draft'),
  isExclusive: types.optional(types.boolean, false),
})

export const PromotionsModel = types
  .model('PromotionsModel')
  .props({
    promotions: types.optional(types.array(PromotionSubmitModel), []),
    listing_setup_step: types.optional(types.number, 7),
    preValueInput: types.maybeNull(types.optional(PromotionSubmitModel, {})),
    options: types.maybeNull(Options),
    status: types.optional(
      types.enumeration('status', ['changed', 'keep']),
      'keep'
    ),
  })
  .actions((self: any) => {
    const setStatus = (value: 'changed' | 'keep') => {
      self.status = value
    }
    const mapValueChanged = ({ add, value: { promotions } }: IValueChange) => {
      if (add === 'add') {
        self.promotions = promotions
        setStatus('changed')
      }
    }

    const update = async (id: string, data: any = null) => {
      const remapData = getSnapshot(self.promotions) as any[]
      const isAllowSavePreValue = Object.entries(remapData).every(
        (item: any) => item[1] && item[1].length > 0
      )
      const URI = `${DOMAIN_ACTION.API.UPDATE_SUPPLIER_LISTING(id)}`
      const newPayload = remapData.map((item: any) => ({
        ...item,
        status: 'submit',
      }))
      const reduceData = isAllowSavePreValue
        ? newPayload
        : newPayload.filter(
            (item: any) => item.title !== '' || item.description !== ''
          )

      const payload = {
        listing_setup_step: 7,
        promotions: reduceData,
      }

      const { promotions } = data || { promotions: [] }
      const paramData = isAllowSavePreValue ? remapData : [...promotions]
      const mapData = { ...data, promotions: paramData }
      const res = await axios.put(URI, data ? mapData : payload)
      return res
    }

    return { setStatus, mapValueChanged, update }
  })
